import React from 'react';
import { useLanguage } from './LanguageContext';
import { motion } from 'framer-motion';
export function Pricing() {
  const {
    t
  } = useLanguage();
  const cards = [{
    title: t.pricing.cards.lactation.title,
    nzd: t.pricing.cards.lactation.nzd,
    usd: t.pricing.cards.lactation.usd,
    highlight: false
  }, {
    title: t.pricing.cards.birthSingle.title,
    subtitle: t.pricing.cards.birthSingle.subtitle,
    nzd: t.pricing.cards.birthSingle.nzd,
    usd: t.pricing.cards.birthSingle.usd,
    highlight: false
  }, {
    title: t.pricing.cards.birthPackage.title,
    subtitle: t.pricing.cards.birthPackage.subtitle,
    nzd: t.pricing.cards.birthPackage.nzd,
    usd: t.pricing.cards.birthPackage.usd,
    highlight: true
  }, {
    title: t.pricing.cards.breastfeeding.title,
    status: t.pricing.cards.breastfeeding.status,
    highlight: false
  }];
  return <section id="pricing" className="py-24 bg-white" data-id="element-194">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-195">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-196">
          <motion.h2 initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl sm:text-4xl font-serif font-medium text-teal-900 mb-4" data-id="element-197">
            {t.pricing.title}
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-slate-600 mb-4" data-id="element-198">
            {t.pricing.subtitle}
          </motion.p>
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-sm text-slate-500 bg-slate-50 inline-block px-4 py-2 rounded-lg" data-id="element-199">
            {t.pricing.note}
          </motion.p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-200">
          {cards.map((card, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`rounded-2xl p-8 flex flex-col h-full ${card.highlight ? 'bg-teal-600 text-white shadow-lg shadow-teal-600/20 scale-105 lg:scale-110 z-10' : 'bg-white border border-slate-100 shadow-sm'}`} data-id="element-201">
              <div className="mb-8" data-id="element-202">
                <h3 className={`text-xl font-medium mb-1 ${card.highlight ? 'text-white' : 'text-slate-800'}`} data-id="element-203">
                  {card.title}
                </h3>
                {card.subtitle && <p className={`text-sm ${card.highlight ? 'text-teal-100' : 'text-teal-600 font-medium'}`} data-id="element-204">
                    {card.subtitle}
                  </p>}
              </div>

              <div className="mt-auto" data-id="element-205">
                {card.status ? <div className="bg-slate-100 text-slate-600 text-sm font-medium px-4 py-2 rounded-lg inline-block" data-id="element-206">
                    {card.status}
                  </div> : <div data-id="element-207">
                    <div className={`text-3xl font-semibold mb-2 ${card.highlight ? 'text-white' : 'text-slate-800'}`} data-id="element-208">
                      {card.nzd}
                    </div>
                    <div className={`text-sm ${card.highlight ? 'text-teal-100' : 'text-slate-500'}`} data-id="element-209">
                      {card.usd}
                    </div>
                  </div>}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}